"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyColumnsContentRenderer = void 0;
const react_1 = __importDefault(require("react"));
const GridColumnMenu_styles_1 = require("../components/GridColumnMenu/GridColumnMenu.styles");
const helpers_1 = require("../../../../helpers");
const StackView_1 = require("../../../../StackView");
const Text_1 = require("../../../../Text");
const View_1 = require("../../../../View");
const emptyColumnsContentRenderer = (customText) => {
    const dotsIconMask = '{{dots}}';
    const text = customText ||
        `Select a column from the Column selection (${dotsIconMask}) to display records`;
    const hasDotsIconMask = text.indexOf(dotsIconMask) >= 0;
    const textParts = text.split(dotsIconMask);
    return (react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, size: { height: helpers_1.SIZE_XL } },
        textParts[0] && react_1.default.createElement(Text_1.Text, null, textParts[0]),
        hasDotsIconMask && (react_1.default.createElement(View_1.View, { align: View_1.VIEW_ALIGN.center, size: { width: helpers_1.SIZE_L, height: helpers_1.SIZE_L }, distribution: View_1.VIEW_DISTRIBUTION.center },
            react_1.default.createElement(GridColumnMenu_styles_1.StyledGridColumnControlIcon, null))),
        textParts[1] && react_1.default.createElement(Text_1.Text, null, textParts[1])));
};
exports.emptyColumnsContentRenderer = emptyColumnsContentRenderer;
//# sourceMappingURL=emptyColumnsContentRenderer.js.map